<template>
    <div id="loading">
    <clip-loader
        :loading="loader.isLoading"
        :color="loader.spinnerColor"
        :size="loader.spinnerSize"
    ></clip-loader>
    <h2 class="heading">Loading</h2>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { mapState } from "vuex";

export default {
    name: 'Loader',
    components: {
        ClipLoader
    },
    computed: {
        ...mapState(['loaderOpen']),
    },
    methods: {
        stepCurrentProgress: function() {
            const it = this.loader.progressSteps[Symbol.iterator]();
            const int = setInterval(() => {
                const next = it.next();
                if (!next.done) {
                this.loader.currentStep = next.value;
                } else {
                clearInterval(int);
                }
            }, this.loader.stepCount);
        },
    },
    watch: {
        loaderOpen: {
            handler(newVal) {
                if (newVal == false) {
                    this.$parent.close();
                }
            }
        }
    },
    data: function() {
        return {
            loader: {
                stepCount: 2500,
                backgroundColor: "linear-gradient(to right, lightgray, gray)",
                opacity: 0.5,
                spinnerSize: "22px",
                spinnerColor: "#485DC5",
                currentStep: "Connecting to our partners.",
                progressSteps: ["Reserving flights.", "Preparing checkout."]
            },
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#loading {
  background: $light;
  margin: auto;
  padding: 2em 5em;
  padding-bottom: 1em;
  border-radius: 8px;
  box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28);
  display: flex;
  max-width: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .heading {
    margin-top: 0.75em;
    font-family: "Helvetica Neue";
    font-size: 1.6em;
    font-weight: bold;
    white-space: nowrap;
  }
}
    
</style>